


































































































































// decoradores
import { Vue, Component } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// tipos

// componentes
import TablaSaldoCuenta from "@/components/saldoCuentas/Tabla.vue";
import FormularioSaldoCuenta from "@/components/saldoCuentas/Formulario.vue";
import { DataFormularioSaldoCuenta } from "@/typings/components/saldoCuentas/formulario";
import DialogoExito from "@/components/DialogoExito.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import InfoSaldoCuenta from "@/components/saldoCuentas/Info.vue";
//import BotonesCrud from "@/components/BotonesCrud.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
//import TituloVista from "@/components/TituloVista.vue";
import {
  SaldoCuenta,
  SaldoCuentas,
  //  Regiones,
} from "@/typings/store/plugins/easyFirestore/saldoCuentas";
//import { DataFormularioRegion } from "@/typings/components/regiones/formulario";
import CargarBancosExcel from "@/components/excel/CargarBancos.vue";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["saldoCuentas"]) {
    return true;
  }

  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to) {
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to);
      }
      return false;
    }
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getUsuarios: "usuarios/get",
    getSaldoCuentas: "saldoCuentas/get",
    getArrayUsuarios: "usuarios/getArray",
    getUsuario: "usuario/get",
    getRutas: "rutas/get",
    getRutasUsuario: "usuario/getRutas",
    getArraySaldoCuentas: "saldoCuentas/getArray",
  }),
  methods: mapActions({
    setSaldoCuenta: "saldoCuentas/set",
    deleteSaldoCuenta: "saldoCuentas/delete",
    insertBatchSaldoCuentas: "saldoCuentas/insertBatch",
    //setArchivo: "archivos/set",
    //deleteArchivo: "archivos/delete",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoEliminar,
    DialogoExito,
    TablaSaldoCuenta,
    FormularioSaldoCuenta,
    InfoSaldoCuenta,
    //BotonesCrud,
    MensajeEliminar,
    CargarBancosExcel,
    //TituloVista,
  },
})
export default class VistaSaldoCuentas extends Vue {
  created(): void {
    if (!routeGuard(this)) {
      return;
    }
  }

  cargando = false;
  dialogoExito = {
    model: false,
    texto: "",
    icono: "",
  };
  search = "";
  saldoCuenta: SaldoCuenta | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  textoEliminar = "¿ESTÁS SEGURO QUE DESEAS ELIMINAR ESTE SALDO?";
  dialogoCargarExcel = false;

  get saldoCuentas(): SaldoCuentas {
    return this.getSaldoCuentas;
  }

  get items(): Array<SaldoCuenta> {
    return this.getArraySaldoCuentas;
  }

  clickItem(val: { id: string } | null): void {
    this.saldoCuenta = val ? this.saldoCuentas[val.id] : null;
  }

  clickPlus(): void {
    this.saldoCuenta = null;
    this.dialogoFormulario = true;
  }

  async clickGuardar(data: DataFormularioSaldoCuenta): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    await this.setSaldoCuenta(doc);
    if (doc.id != this.saldoCuenta?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Saldo creado con éxito!",
        icono: require("../assets/icons/double-check-duo.svg"),
      };
    }
    if (doc.id == this.saldoCuenta?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Saldo editado con éxito!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.saldoCuenta = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = {
      model: false,
      texto: "",
      icono: "",
    };
  }

  clickEliminar(): void {
    const saldoCuenta = this.saldoCuenta;
    if (!saldoCuenta?.id) {
      console.error("error id: ", saldoCuenta);
      return;
    }
    this.deleteSaldoCuenta(saldoCuenta.id);
    this.saldoCuenta = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(saldoCuenta: SaldoCuenta): void {
    if (!saldoCuenta.id) {
      console.error("error id: ", saldoCuenta);
      return;
    }
    const doc = this.saldoCuentas[saldoCuenta.id];
    if (doc) {
      this.saldoCuenta = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.saldoCuenta = null;
  }

  abrirDialogoFormulario(saldoCuenta: SaldoCuenta): void {
    if (!saldoCuenta.id) {
      console.error("error id: ", saldoCuenta);
      return;
    }
    const doc = this.saldoCuentas[saldoCuenta.id];
    if (doc) {
      this.saldoCuenta = doc;
      this.dialogoFormulario = true;
    }
  }

  abrirDialogoEliminar(saldoCuenta: SaldoCuenta): void {
    if (!saldoCuenta.id) {
      console.error("error id: ", saldoCuenta);
      return;
    }
    const doc = this.saldoCuentas[saldoCuenta.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.saldoCuenta = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.saldoCuenta = null;
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.saldoCuenta = null;
  }
}
